import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { weddingQuery } from "@bridewell/api-client";
import { Spinner } from "@/components/ui/misc";

/** Resolve wedding + access once; the app layout keeps navigation mounted across every destination. */
export const Route = createFileRoute("/app/w/$weddingId")({
  loader: ({ context, params }) => context.queryClient.ensureQueryData(weddingQuery(params.weddingId)),
  component: () => (
    <Suspense fallback={<Spinner />}>
      <Outlet />
    </Suspense>
  ),
});
